<template>
  <div class="steps-box relative">
    <div class="activeStep">
      <i class="number normal inline-block">1</i>
      <span class="line" :class="currentStep > 1 ? 'lineActive' : ''"></span>
      <!--确认币种-->
      <p class="bold">{{ $t('8000083') }}</p>
    </div>
    <div :class="currentStep >= 2 ? 'activeStep' : ''">
      <i class="number normal inline-block">2</i>
      <span class="line" :class="currentStep > 2 ? 'lineActive' : ''"></span>
      <!--填写信息-->
      <p class="bold">{{ $t('10000015') }}</p>
    </div>
    <div :class="currentStep >= 3 ? 'activeStep' : ''">
      <i class="number normal inline-block">3</i>
      <span class="line" :class="currentStep > 3 ? 'lineActive' : ''"></span>
      <!--上币提示-->
      <p class="bold">{{ $t('8000084') }}</p>
    </div>
    <div :class="currentStep == 4 ? 'activeStep' : ''">
      <i class="number normal inline-block">4</i>
      <!--创建成功-->
      <p class="bold">{{ $t('8000085') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "stepView",
  props: {
    currentStep: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/mixin";
@import "../../../assets/css/variableName";
[dir='ltr'] .steps-box {
  .activeStep {
    div {
      padding: 10px 24px 0 0;
    }
  }
}

[dir='rtl'] .steps-box {
  .activeStep {
    div {
      padding: 10px 24px 0 0;
    }
  }
}
.steps-box {
  width: 100%;
  position: relative;
  background: rgba(255, 199, 43, 0.05);
  display: flex;
  justify-content: center;
  padding: torem(20) torem(16);
  margin: 0 auto torem(16);

  div {
    i.number {
      width: torem(16);
      height: torem(16);
      background-color: #EAECEF;
      line-height: 1.5;
      font-size: torem(12);
      -webkit-transform: scale(0.84);
      color: #7F8490;
      text-align: center;
      border-radius: 50%;
    }
    span.line {
      display: inline-block;
      background-color: #F0F0F0;
      height: torem(2);
      width: torem(70);
      margin: 0 torem(4) torem(4) 0;
    }

    .line.lineActive {
      background: #FFC72B;
    }

    div {
      color: #7F8490;
      line-height: 1.5;
      padding: torem(10) torem(4) 0 0;
    }

    p {
      font-size: torem(12);
      color: #7F8490;
      margin-top: torem(8);
      line-height: 1.1;
      width: torem(60);
    }
  }
  div.activeStep {
    i.number {
      color: #000922;
      background: #FFC72B;
    }

    p {
      color: #000922;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/compontents/freeZone/createSymbol/stepView.vue